import React from 'react';
import { AppBar, Toolbar, Typography, IconButton, Box } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { ReactComponent as OrangeLogo } from '../../assets/images/orange-logo.svg';
import UserMenu from './UserMenu';
import TeamSelector from './TeamSelector';
import { useTeam } from '../../context/TeamContext';

const Header = ({ toggleSidebar }) => {
  const { switchTeam } = useTeam();
  return (
    <AppBar 
      position="fixed" 
      sx={{ 
        zIndex: (theme) => theme.zIndex.drawer + 1,
        backgroundColor: 'background.paper',
        color: 'text.primary',
        boxShadow: '0 1px 8px rgba(0,0,0,0.1)'
      }}
    >
      <Toolbar sx={{ justifyContent: 'space-between' }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <IconButton
            color="inherit"
            aria-label="toggle sidebar"
            onClick={toggleSidebar}
            edge="start"
            sx={{ 
              mr: 2,
              '&:hover': {
                backgroundColor: 'action.hover'
              }
            }}
          >
            <MenuIcon />
          </IconButton>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Box 
              sx={{ 
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                height: 40,
                width: 40,
                mr: 2,
                '& svg': {
                  height: '100%',
                  width: '100%'
                }
              }}
            >
              <OrangeLogo />
            </Box>
            <Typography 
              variant="h6" 
              noWrap 
              component="div"
              sx={{ 
                fontWeight: 400,
                color: '#000',
              }}
            >
              Gestion des Astreintes
            </Typography>
          </Box>
        </Box>
        
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 3 }}>
          <TeamSelector onTeamChange={switchTeam} />
          <UserMenu />
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
